/* eslint-disable @typescript-eslint/no-explicit-any */
export const getTranslations =
  (translations: any) =>
  (language: string, key: string, format: any = null): string => {
    const messages = translations.getLoadedMessages(language);

    return messages ? messages[key].format(format) : 'Error';
  };
